import {getRequest} from './request';
import {DogDestructivePhrases} from '../common/types/dog-destructive-phrases';

export const getDogDestructivePhrases = async (): Promise<DogDestructivePhrases[]> => {
    return await getRequest<DogDestructivePhrases[]>(`dog-destructive-phrases`).then(
        (res) => res.data,
    );
};
